// Document approval statuses (Faktuurin.ApprovalStatus / CreditnotaIN.ApprovalStatus) and line statuses.
export const STATUS = Object.freeze({ TO_ASSIGN: 'TO_ASSIGN', PENDING: 'PENDING', APPROVED: 'APPROVED', REJECTED: 'REJECTED', LEGACY: 'LEGACY' });

const META = {
  TO_ASSIGN: { label: 'To assign', tone: 'attention', description: 'Nobody is responsible for this document yet.' },
  PENDING: { label: 'Pending', tone: 'warning', description: 'Waiting for approval.' },
  APPROVED: { label: 'Approved', tone: 'success', description: 'Fully approved.' },
  REJECTED: { label: 'Rejected', tone: 'critical', description: 'Sent back to accounting; may not be paid.' },
  LEGACY: { label: 'Legacy', tone: undefined, description: 'Closed before the approval flow existed (never approved).' }
};

export function labelFor(status) {
  return META[status]?.label || 'No approval';
}

export function toneFor(status) {
  return META[status]?.tone;
}

export function describeStatus(status) {
  return META[status]?.description || 'Not part of the approval flow.';
}

export const STATUS_CHOICES = Object.keys(META).map((key) => ({ key, value: key, label: META[key].label }));

export const OPEN_STATUSES = [STATUS.TO_ASSIGN, STATUS.PENDING, STATUS.REJECTED];
